import React, { useEffect, useState } from "react";
import { Button, Row, Form, InputGroup, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SideMenu from "../../../Components/SideMenu";
import {
  getUsers,
  resetUserRecord,
  userUpdate,
} from "../../../reducers/commonReducer";
import UserAction from "./UserAction";
import moment from "moment";

const Users = () => {
  const [search, setSearch] = useState();
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const [userStatus, setUserStatus] = useState();

  useEffect(() => {
    dispatch(resetUserRecord());
    let timeOut = setTimeout(() => {
      dispatch(
        getUsers({
          search: search,
        })
      );
    }, 800);
    return () => clearTimeout(timeOut);
  }, [search]);
  const { getUsersData, usersBlank } = useSelector(
    (state) => state.commonReducer
  );
  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        <Row className="mb-1">
          <Col md={4}>
            <InputGroup>
              <InputGroup.Text id="inputGroup-sizing-default">
                <i className="bi bi-search"></i>
              </InputGroup.Text>
              <Form.Control
                aria-label="Default"
                placeholder="Search anything..."
                aria-describedby="inputGroup-sizing-default"
                onChange={(e) => setSearch(e.target.value)}
              />
            </InputGroup>
          </Col>
        </Row>
        <table className="table mt-4 w-100">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Date</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {!!getUsersData &&
              getUsersData?.map((data, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr key={data?.id}>
                      <td>{data?.name ? data?.name : data?.username}</td>
                      <td>{data?.email}</td>
                      <td>{data?.phone}</td>
                      <td>{moment(data.createdAt).format("DD MMM YY")}</td>
                      {/* <td>
                        {`${
                          data?.address?.addressline1
                            ? data.address.addressline1
                            : ""
                        } 
                          ${
                            data?.address?.addressline2
                              ? data.address.addressline2
                              : ""
                          },
                          ${data?.address?.city ? data?.address?.city : ""} - ${
                          data?.address?.zipcode ? data?.address?.zipcode : ""
                        },
                          ${data?.address?.state ? data?.address?.state : ""}`}
                      </td> */}
                      <td>
                        <b>
                          {data?.status ? (
                            <span className="text-success">Active</span>
                          ) : (
                            <span className="text-danger">InActive</span>
                          )}
                        </b>
                      </td>
                      <td>
                        <UserAction
                          api={userUpdate}
                          title={"Update"}
                          name={data?.name}
                          phone={data?.phone}
                          email={data?.email}
                          status={data?.status}
                          id={data?.id}
                          tempUser={data?.tempUser}
                        />
                        {data?.tempUser && <Button variant="success" className="m-2" onClick={async() => {
                          await dispatch(userUpdate({
                          id: data?.id,
                          tempUser: false
                        }))
                        await dispatch(getUsers());
                        }}>Save</Button>}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
        {!!usersBlank && usersBlank.length > 0 ? (
          <Row>
            <Col md={12}>
              <Button
                className="w-100"
                variant="success"
                onClick={() => {
                  setPage(page + 1);
                  dispatch(
                    getUsers({
                      search: search,
                      page: page + 1,
                      updatedUser: userStatus,
                    })
                  );
                }}
              >
                Load More
              </Button>
            </Col>
          </Row>
        ) : (
          <p className="text-center">
            <b>No record found 😔.</b>
          </p>
        )}
      </div>
    </>
  );
};

export default Users;
